<script>
import Layout from "@/router/layouts/contracts";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  data() {
    return {
      contract: {
        status: '',
        url: '',
      }
    };
  },
  methods: {
    getContract() {
      api
        .get('contracts')
        .then((response) => {
          if (response.data.status == 'success') {
            if (response.data.contract.status == 'sent') {
              this.contract = response.data.contract;
            } else {
              this.$router.push('/');
            }
          } else {
            this.$router.push('/');
          }
        })
    },
  },
  mounted() {
    this.getContract()

    setInterval(() => {
      this.getContract()
    }, 30000)
  }
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-lg-8 col-xl-6">
        <div v-if="contract.status == 'sent'" class="px-4 py-3 text-center">
          <h5>Para continuar, leia e assine o contrato!</h5>
          <a class="btn btn-default btn-lg mt-3" :href="contract.url" target="_blank">Assinar Contrato</a>
        </div>
      </div>
    </div>
  </Layout>
</template>
